import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ModuleLayout from "../../layouts/ModuleLayout";
// Pages
import StockOverview from "../../components/Admin/Inventory/StockOverview";
import InventoryItemsPage from "./InventoryItemsPage";
import RecipesPage from "./RecipesPage";
import UoMPage from "./UoMPage";

export default function InventoryDashboard() {
  return (
    <ModuleLayout>
      <div className="p-6">
        <Routes>

          {/* ✅ FIXED DEFAULT ROUTE */}
          <Route index element={<StockOverview />} />

          <Route path="items" element={<InventoryItemsPage />} />
          <Route path="recipes" element={<RecipesPage />} />
          <Route path="uom" element={<UoMPage />} />

          {/* fallback */}
          <Route path="*" element={<Navigate to="" replace />} />

        </Routes>
      </div>
    </ModuleLayout>
  );
}